import React, { useCallback, useEffect, useState } from "react";
import s from './OneOnOne.module.css';
import { useNavigate } from "react-router-dom";
import {getData, postData} from '../middleware/apiMiddleware';
import {modifiedDateWithYear, modifiedDate, modifiedDateDayMonthOnly, getToday, isValidYYYYMMDD, modifiedDateWithoutTime} from '../middleware/dateControl';
import SmallCalendar from '../components/SmallCalendar';
import TutorGroupComponent from '../components/TutorGroupComponent';
import moment from 'moment';
import trial from'../asset/trial.png';
import renewableEnergy from'../asset/renewable-energy.png';
import renewableEnergyDark from'../asset/renewable-energy-dark.png';

export default function OneOnOne(prop) {	
	const navigate = useNavigate();
	
  let tutorId = prop.tutorId;
	//if (prop.tutorGroups[0]) {prop.tutorGroups[0].isShow = true;}
	
	const [tutorGroups, setTutorGroups] = useState(prop.tutorGroups);
	const [clickedUser, setClickedUser] = useState(null);
	
	const [flag, setFlag] = useState({
		showZoom:false,
	});
	
	function CheckBox({label, flagKey, flag, setFlag, ...props}) {
		return (<div className="checkbox-wrapper">
			<label>
				<input
					type="checkbox"
					checked={flag}
					onChange={() => setFlag((prev) => ({...prev, [flagKey]: !flag}))}
					className={flag ? "checked" : ""}
					{...props}
				/>
				<span>{label}</span>
			</label>
		</div>);
	}
	
	useEffect(() => {
	}, []);
	
	const toggleIsShow = (indexV) => {
		let tmp = tutorGroups[indexV];
		tmp.isShow = (!tmp.isShow) ? true : false;
		
		
		tutorGroups[indexV] = tmp;
		setTutorGroups([...tutorGroups]);
	}
	
	
	const toggleRenewal = (indexV) => {
		let tmp = tutorGroups[indexV];
		tmp.isRenewal = (tmp.isRenewal == 1) ? 0 : 1;
		
		tutorGroups[indexV] = tmp;
		setTutorGroups([...tutorGroups]);
		
		let obj = {
			tutorGroupId: tmp.tutorGroupId, 
			isRenewal: tmp.isRenewal	
		}
		
		postData("tutorApi/toggleRenewal", obj, navigate)
	}
	
	const setTrialSuccessDate = (indexV, successDate) => {
		let tmp = tutorGroups[indexV].zooms[0];
		tmp.trialSuccessBuyTime = successDate + " 00:00:00";
		
		tutorGroups[indexV].zooms[0] = tmp;
		setTutorGroups([...tutorGroups]);
		
		let obj = {
			zoomId: tmp.zoomId, 
			trialSuccessBuyTime: tmp.trialSuccessBuyTime
		}
		
		postData("tutorApi/trialSuccessBuyTime", obj, navigate)
	}
	
	const [currentModalIndex, setCurrentModalIndex] = useState(-1);
	
	const [cTutorGroupId, setCTutorGroupId] = useState();
	
	const TrialSuccessDateModal = ({indexV, testDate}) => {
		const [myTestDate, setMyTestDate] = useState(testDate ?? getToday());
		return (<div className={s.trialSuccessDateModal}>
			<div>
				<input type="date" value={myTestDate} onChange={e=>setMyTestDate(e.target.value)}/>
				{(isValidYYYYMMDD(myTestDate)) && (<div className={s.confirmBtn}><div className="general-red-btn general-red-btn-default" onClick={()=>{setTrialSuccessDate(indexV, myTestDate)}}>confirm</div></div>)}
			</div>
		</div>)
	}	
	
	const setTrialSuccessPanelIndex = (indexV) => {		
		if (currentModalIndex == indexV) {
			setCurrentModalIndex(-1);
		} else {
			setCurrentModalIndex(indexV)
		}
	}
	
	return (<div className={s['container']}>
		<div className={s.guideHolder}>
			<p><span>Renew - </span>Yes</p>
			<img className={s.renewIcon} src={renewableEnergy}  />
			<p><span>|</span> No</p>
			<img className={s.renewIcon} src={renewableEnergyDark}  />
			
			<p>&nbsp;&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </p>
			
			<p><span>Trial- </span>success Date</p>
			<div className={s.trialSuccessDateSampleDateHolder}><div className={s.trialSuccessDateSampleDate}>1 Jan</div></div>
			<p><span>|</span> Unknown</p>
			<div className={s.trialSuccessDateSample}>
				<div>?</div>
			</div>
		</div>
		
		{/*<div className={s.checkboxHolder}>
			<CheckBox label="Show Zoom" flagKey="showZoom" flag={flag.showZoom} setFlag={setFlag}/>
</div>*/}
		{
			tutorGroups.map((v, indexV) => {
				return (<div key={v.tutorGroupId} className={s.tutorGroupListDiv}>
				
				<li className={(v.tGWhiteBox != "Trial Lesson") ? s.tutorGroupListLi : [s.tutorGroupListLi, s.tutorGroupListTrialLi].join(' ')}>
					<ul onClick={()=>setCTutorGroupId(v.tutorGroupId)}>{v.tutorGroupId} {((v.tGWhiteBox != "Trial Lesson")) ? "(" + v.zooms.length + " Lessons)" : <div>TRIAL</div>}</ul>
					{
						(v.tGWhiteBox == "Trial Lesson" && v.zooms[0]) && (<>
						<ul>{modifiedDateWithYear(v.zooms[0].zStartDate)}</ul>
						<ul></ul>
						<ul></ul>
						</>)
					}
					{
						(v.tGWhiteBox != "Trial Lesson") && (<><ul>{modifiedDateWithYear(v.tgStartDate)}</ul>
						<ul>-></ul>
						<ul>{modifiedDateWithYear(v.tgEndDate)}</ul></>)
					}
					<ul>{v.isTriggerBonus}</ul>
					<ul>
						{
							(v.tGWhiteBox != "Trial Lesson") && (
								<span onClick={()=>toggleRenewal(indexV)} >
									{(v.isRenewal == 1) ? <img className={s.renewIcon} src={renewableEnergy}  /> : <img className={s.renewIcon} src={renewableEnergyDark}  />}
								</span>)
						}
						{
							(v.tGWhiteBox == "Trial Lesson" && v.zooms[0]) && (<>
									<div className={s.trialHolder}>
										{ (v.zooms[0].trialSuccessBuyTime) && (
											<div className={s.trialSuccessDate} onClick={()=>{setTrialSuccessPanelIndex(indexV);}}>
												{modifiedDateDayMonthOnly(v.zooms[0].trialSuccessBuyTime)}
											</div>)
										}
										{ (!v.zooms[0].trialSuccessBuyTime) && (
											<div className={s.trialSuccessDateUnknown}>
												<div onClick={()=>{setTrialSuccessPanelIndex(indexV);}}>?</div>
											</div>)
										}
										<div>{(currentModalIndex == indexV) && <TrialSuccessDateModal indexV={indexV} testDate={modifiedDateWithoutTime(v.zooms[0].trialSuccessBuyTime)}/>}</div>
									</div>	
								</>)
						}
					</ul>
					<ul>{v.tGTitle}</ul>
					<ul>{v.students.map(stu=>{return(
						<div>
						<span onClick={()=>{setClickedUser(stu.userId)}} key={v.tutorGroupId + '-' + stu.userId} className={(clickedUser == stu.userId) ? s.clickedUser : s.normalUser}>({stu.userId}){stu.username}</span>
						</div>
						)
						
					})}</ul>
				</li>
				{
					/*(v.isShow) && (<TutorGroupComponent tutorGroupId={v.tutorGroupId}/>)*/
				}
				
				
				{/*
				{(flag.showZoom) && (<div className={s.zoomHolder}>{
					v.zooms.map((z) => {
						return (
							
							<div key={z.zoomId} className={s.zoomCard}>
								<div>
									<div><span className={s.spanBold}>{z.zoomId}</span></div>
									<div className={s.spanLight}>{z.zTitle}</div>
									<div>{modifiedDate(z.zStartDate)}</div>
								</div>
								<div><SmallCalendar date={z.zStartDate}/></div>
							</div>);
						
					})
					
					
				}</div>)
				}*/}
				
				</div>);
				
			})
			
			
		}
		<TutorGroupComponent tutorGroupId={cTutorGroupId} setTutorGroupId={setCTutorGroupId}/>
		

	</div>);
}